module.exports = __webpack_public_path__ + "static/sport/tag-login.c3be307.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport5/tag-login.png
// module id = bgwC
// module chunks = 0